import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of, throwError } from 'rxjs';
import { AuthUtils } from 'app/core/auth/auth.utils';
import { environment } from 'environments/environment';

import { AuthRoute } from './guards/authRoute';
import { NavigationService } from '@core/navigation/navigation.service';


@Injectable({
    providedIn: "root",
})

export class AuthService {
    private _authenticated: boolean = false;


    /**
     * Constructor
     */
    constructor(
        private _httpClient: HttpClient,
        
        private authRoute: AuthRoute,
        private navigation : NavigationService
    ) {
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Accessors
    // -----------------------------------------------------------------------------------------------------

    /**
     * Setter & getter for access token
     */
    set accessToken(token: string) {
        localStorage.setItem('tokeninpro', token);
    }

    get accessToken(): string {
        return localStorage.getItem('tokeninpro') ?? '';
    }


    set user(user: any) {
        localStorage.setItem('user', user)
    }

    get user(): string {
        return localStorage.getItem('user') ?? '';
    }

    set id_operadora(id: string) {
        localStorage.setItem('id_operadora', id)
    }

    set codigo_sicah(id: string) {
        localStorage.setItem('codigo_sicah', id)
    }


    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Forgot password
     *
     * @param email
     */
    forgotPassword(email: string): Observable<any> {
        return this._httpClient.post('api/auth/forgot-password', email);
    }

    /**
     * Reset password
     *
     * @param password
     */
    resetPassword(password: string): Observable<any> {
        return this._httpClient.post('api/auth/reset-password', password);
    }

    /**
     * Sign in
     *
     * @param credentials
     */
    async signIn(credentials: { user: string; pass: string }) {
        if (this._authenticated) {
            return throwError('User is already logged in.');
        }

        const form = new FormData()
        form.append('user', credentials.user)
        form.append('pass', credentials.pass)

        const response = await fetch(environment.apiURL + 'usuarios/login', {
            method: "POST",
            body: form
        }).then((r: any) => {
            let promes = r.json()
            return promes.then(response => {

                if (response) {
                    this._authenticated = true;



                    this.accessToken = response.token;

                    this.id_operadora = response.id_operadora
                    this.codigo_sicah = response.codigo_sicah


                    this.user = JSON.stringify({
                        id: response.id_user,
                        username: response.username,
                        email: response.email,
                        avatar: false,
                        first_name:response.first_name,
                        last_name:response.last_name
                    })
                    






                    return response
                }
            })
        })

        return response
    }




    /**
     * Sign out
     */
    signOut(): Observable<any> {
        // Remove the access token from the local storage
        localStorage.removeItem('tokeninpro');
        localStorage.removeItem('user');
        localStorage.removeItem('id_operadora');
        localStorage.removeItem('codigo_sicah');

        // Set the authenticated flag to false
        this._authenticated = false;

        // Return the observable
        return of(true);
    }

    /**
     * Sign up
     *
     * @param user
     */
    signUp(user: { name: string; email: string; password: string; company: string }): Observable<any> {
        return this._httpClient.post('api/auth/sign-up', user);
    }

    /**
     * Unlock session
     *
     * @param credentials
     */
    unlockSession(credentials: { email: string; password: string }): Observable<any> {
        return this._httpClient.post('api/auth/unlock-session', credentials);
    }

    /**
     * Check the authentication status
     */
    check(): boolean {

        // Check if the user is logged in
        if (this._authenticated) {
            return true;
        }

        // Check the access token availability
        if (!this.accessToken) {
            return false;
        }


        if (AuthUtils.isTokenValid(this.accessToken)) {
            return false
        }


        // Check the access token expire date
        if (AuthUtils.isTokenExpired(this.accessToken)) {
            return false;
        }



        return true

        // If the access token exists and it didn't expire, sign in using it
        // return this.signInUsingToken();
    }







}
